import React from "react"
import types from "prop-types"
import { isEmpty } from "lodash-es"
import useFormSubmissionsListSettings from "hooks/useFormSubmissionsListSettings"
import { useHiddenSidebar } from "hooks"
import SvgSpriteIcon from "shared/SvgSpriteIcon"
import withReduxProvider from "shared/withReduxProvider"
import Sidebar from "./Sidebar"
import SubmissionContent from "./Content/SubmissionContent"

const FormSubmissionList = ({ categories, categorySlug }) => {
  useFormSubmissionsListSettings({ categories, defaultCategorySlug: categorySlug })

  const { hiddenSidebar, toggleSidebar } = useHiddenSidebar()

  // When a non-admin user has never been granted access to a form submission.
  if (isEmpty(categories)) {
    return (
      <>
        <h1 className="header-title tracking-tight absolute-horizontal-center">
          Submissions
        </h1>
        <div className="flex flex-col w-full items-center pt-16">
          <SvgSpriteIcon iconName="submissions" className="w-16 h-16 mb-4" />
          <span>There are no form submissions for you right now.</span>
        </div>
      </>
    )
  }

  return (
    <>
      <Sidebar hiddenSidebar={hiddenSidebar} />
      <SubmissionContent
        hiddenSidebar={hiddenSidebar}
        toggleSidebar={toggleSidebar}
      />
      <div />
    </>
  )
}

FormSubmissionList.propTypes = {
  categories: types.arrayOf(types.object).isRequired,
  categorySlug: types.string.isRequired,
}

export default withReduxProvider(FormSubmissionList)
